/**
 * Z-index ranges for overlay components.
 * Each stacked overlay increments by STEP within its range.
 *
 * Visual order (front to back):
 *   Dropdowns (100) > Dialogs (50+) > Panels (40+) > Page content
 */
export const Z_INDEX = {
  PANEL_BASE: 40,
  PANEL_STEP: 10,
  DIALOG_BASE: 50,
  DIALOG_STEP: 10,
  DROPDOWN: 100,
} as const;
